import { tv } from 'tailwind-variants'

const clsxClasses = tv({ base: [] })
const cn = (...args: (string | undefined)[]) => clsxClasses({ class: [args] })
export type { VariantProps } from 'tailwind-variants'
export { tv, cn }
